import './skeleton-program.scss';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const SkeletonProgram = () => {

    return (
        <div className='skeleton-program'>
            <Grid container className='container-program-detail' justifyContent={'center'} spacing={4}>
                <Grid item xs={5}>
                    <Grid container>
                        <Grid item xs={6}>
                            {/* img */}
                            <Skeleton variant="rectangular" height={300} />
                        </Grid>
                        <Grid item xs={6} className='info-program'>
                            {/* info */}
                            <Skeleton variant="rectangular" height={20}  />
                            <Skeleton variant="rectangular" height={10}  />
                            <br />
                            <Skeleton variant="rectangular" height={10}  />
                            <Skeleton variant="rectangular" height={20}  />
                            <br /><br />
                            <Skeleton variant="rectangular" height={20} width={100} />
                        </Grid>
                    </Grid>
                    {/* desciption */}
                    <Skeleton variant="rectangular" height={20} width={300} />
                    <Skeleton variant="rectangular" height={100} />
                </Grid>
                <Grid item xs={7}>
                    {/* cards */}
                    <Grid container className='skeleton-class-program'>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                        <Grid item xs={6} className='class-program'>
                            <Skeleton variant="rectangular" height={200} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div >
    );
}